<template>
  <div class="addbtncontent">
    <div class="add-btn" @click="addbtnClick">
      <span class="plus">+</span>
      <span>{{ value }}</span>
    </div>
    <span v-if="isShowSpan">请选择PDF格式文件上传</span>
    <div class="inputdiv">
      <input
        id="upFileid"
        ref="upfile"
        type="file"
        @change="fileChange"
        accept="image/*, application/msexcel, application/msword, application/pdf, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        multiple="multiple"
      />
    </div>
    <!-- accept="image/*, application/msexcel, application/msword, application/pdf, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.openxmlformats-officedocument.wordprocessingml.document" -->
    <warningModal v-if="showmodal" @closeModal="closeModal"></warningModal>
  </div>
</template>
<script>
import API from "../../../../service/index";
import api from "../../../../service/modules/complaintApis";
import commonAPI from "../../../../utils/common";
import store from "../../../../store/index";
import moment from "moment";

import warningModal from './warningModal';
// import eventBus from '../../../../main';
export default {
  props: {
    value: {
      type: String,
      default: () => {
        return "新增附件";
      },
    },
    isShowSpan: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    isGoAndroidandIOS: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    monitorType: {
      type: String,
      default: () => {
        return "";
      },
    },
    needEmit: {
      //如果是 直接返回 到父组件，值为 true
      type: Boolean,
      default: () => {
        return false;
      },
    },
    year: {
      type: [String, Number],
      default: () => {
        return "";
      },
    },
    quarter: {
      type: [String, Number],
      default: () => {
        return "";
      },
    },
    area: {
      type: String,
      default: () => {
        return "";
      },
    },
    id: {
      type: String,
      default: () => {
        return "";
      },
    },
    submitAuth: {
      type: String,
      default: () => {
        return "";
      },
    },
  },
  components:{ warningModal },
  data() {
    return {
      cosArg: null,
      cos: null,
      tempFile: [], //用来存 上传到服务器的文件
      tempFileList: [], //用来 存 已经上传的文件的 名字 大小 类型等数据
      temEvent: null,
      showmodal: false
    };
  },
  created() {
    this.getSession();
  },
  watch: {
    needEmit() {},
  },
  methods: {
    closeModal(){
      this.showmodal = false;
    },
    resetFile() {
      if (this.temEvent) {
        this.temEvent.target.value = "";
      }
    },
    addbtnClick() {
      if (this.isGoAndroidandIOS) {
        const a = this.$el.getElementsByTagName("input")[0];
        if (a) {
          a.click();
        }
      } else {
        this.$emit("addbtnClick");
      }
    },
    fileChange(event) {
      this.tempFile = [];
      this.tempFileList = [];
      this.tempFile = event.target.files;
      this.temEvent = event;
      console.log('-----文件类型----类型:', event);
      // console.log("--------标识文件---文件名:", event.target.files[0].name);
      // console.log("-------标识文件----文件大小:", event.target.files[0].size);
      if (this.tempFile.length <= 0) {
        return false;
      }
      if (this.tempFile.length > 10) {
        this.$toast("最多可上传10个附件文件");
        return false;
      }
      for( let i = 0 ; i< this.tempFile.length; i++){
         if(this.tempFile[i].type !== 'application/pdf'){
           //提示 只能选PDF
            this.showmodal = true;
            this.$refs.upfile.value = null;
            return false;
         }
      }
      // console.log("-----版本标记1.1.2,测试文件上传");
      this.uploadFile();
    },
    getSession() {
      // 存储桶信息  ----上传时间 ----资源名称
      API.getCOStoken({}).then((res) => {
        // console.log("---token:", res);
        this.cosArg = res.data;
        this.cos = new COS({
          getAuthorization: function (options, callback) {
            callback({
              TmpSecretId: res.data.tmpSecretId,
              TmpSecretKey: res.data.tmpSecretKey,
              XCosSecurityToken: res.data.sessionToken,
              ExpiredTime: res.data.expiredTime,
            });
          },
        });
        // this.uploadFile();
      });
    },
    openWindow(title, path) {
      window.yyn.invokeJSB(
        "openWindow",
        {
          openUrl: this.globalApp.getSystemInfo().host + "web/#" + path,
          isFullScreen: 0,
          setTitle: title,
          needLoading: 1,
        },
        (cb) => {
          console.log(cb, "callback");
        }
      );
    },
    async uploadFile() {
      let cosKey = "";
      const _this = this;
      // console.log("this.tempFile:", this.tempFile);
      // console.log("-------文件大小:", this.tempFile[0].size);
      // console.log("-------存储桶信息:", this.cosArg.bucket);
      // console.log(
      //   "------开始时间:",
      //   moment(new Date().getTime()).format("YYYY-DD-MM HH:mm:ss")
      // );
      // console.log("-----文件名:", this.tempFile[0].name);
      // let name = this.tempFile[0].name.substring( 0, this.tempFile[0].name.lastIndexOf('.'))
      // console.log('----截取后的文件名：', name)
      store.dispatch("refund/setLoading", true);
      for (let i = 0; i < this.tempFile.length; i++) {
        let cosKey = `${commonAPI.getProcess()}/${new Date().getTime()}/${
          this.tempFile[i].name
        }`;
        this.cos.putObject(
          {
            Bucket: _this.cosArg.bucket,
            Region: _this.cosArg.region,
            Key: cosKey,
            Body: _this.tempFile[i],
            onTaskReady: function (taskId) {
              console.log("上传任务开始(taskId)：", taskId);
            },
            onHashProgress: function (progressData) {
              console.log("校验中", JSON.stringify(progressData));
            },
            onProgress: function (progressData) {
              console.log("上传中", JSON.stringify(progressData));
            },
          },
          (err, res) => {
            // console.log(err, res);
            console.log("----上传之后返回的结果res：", res);
            console.log("-----上传之后的返回结果err:", err);

            if (!err) {
              let name = _this.tempFile[i].name.substring( 0, _this.tempFile[i].name.lastIndexOf("."));
              console.log('截取字符串文件名:', name);
              let filetype =  _this.tempFile[i].name.substring( _this.tempFile[i].name.lastIndexOf(".") + 1, _this.tempFile[i].name.length);
              console.log('截取字符串文件类型:', filetype);
              let obj = {
                fileName: name,
                // fileType: commonAPI.getFileType(_this.tempFile[i].type),
                fileType: commonAPI.getFileType(filetype),
                fileSize: commonAPI.fixBtoKBorMB(_this.tempFile[i].size),
                fileSource: "app",
                fileKind: "common",
                filePath: cosKey,
                // fileUrl: res.Location,
              };
              _this.tempFileList.push(obj);
              // console.log("-----i:", i);
              // console.log("----length:", this.tempFile.length);
              if (i + 1 >= _this.tempFile.length) {
                store.dispatch("refund/setLoading", false);
                console.log("查看上传的文件:", _this.tempFileList);
                if (_this.needEmit) {
                  _this.$emit("fields", _this.tempFileList);
                } else {
                  _this.$router.push({
                    path: "/appraise/add_enclosure",
                    query: {
                      fields: _this.tempFileList,
                      monitorType: _this.monitorType,
                      year: _this.year,
                      quarter: _this.quarter,
                      area: _this.area,
                      id: _this.id,
                      submitAuth: _this.submitAuth,
                    },
                  });
                }
              }
            }
            // this.$refs.upfile.value = ''; // 只要走这里，就把input的value设置为空，不然上传的文件如果删掉，会无法选中刚才的文件。
          }
        );
      }
    },
  },
};
</script>
<style lang="less" scoped>
.addbtncontent {
  width: 100%;
  height: 100%;
  text-align: center;
  span {
    display: inline-block;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(204, 204, 204, 1);
    margin-top: 12px;
  }
}
.add-btn {
  width: 100%;
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(54, 178, 116, 1);
  border-radius: 3px;
  border: 1px dashed rgba(54, 179, 116, 1);
  .plus {
    line-height: 36px;
    padding-right: 4px;
    vertical-align: top;
  }
  span {
    margin-top: 0;
    line-height: 40px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(54, 178, 116, 1);
  }
}
.inputdiv {
  display: none;
}
</style>
